<template>
    <div class="h-full">
        <ProgressBar ref="progressBar" />
        <router-view :key="$route.path" />
        <portal-target name="modals" multiple></portal-target>
    </div>
</template>

<script>

import ProgressBar from '@mobile/components/ProgressBar';

export default {
    components: { ProgressBar },
};

</script>
